import * as React from 'react';
import {Spinner} from "react-bootstrap";

export function SpinnerPadded() {
    return (<div className={'py-5'} style={{textAlign: "center"}}>
        <Spinner animation="border" role="status"/>
    </div>);
}
